import React from 'react';
import { Link } from 'react-router-dom';
import { Settings } from 'lucide-react';
import { ProfileHeroLinkedIn } from '../components/ProfileHeroLinkedIn';
import { MatchContext } from '../components/MatchContext';
import { IntentLinks } from '../components/IntentLinks';
import { AgentCapabilities } from '../components/AgentCapabilities';
import { PerformanceMetrics } from '../components/PerformanceMetrics';
import { MarketsServed } from '../components/MarketsServed';
import { ActiveListings } from '../components/ActiveListings';
import { SellerReviews } from '../components/SellerReviews';
export function PublicProfile() {
  return <div className="min-h-screen bg-brand-offwhite font-sans selection:bg-brand-sage selection:text-brand-forest pb-24" data-id="element-1468">
      <main data-id="element-1469">
        <ProfileHeroLinkedIn data-id="element-1470" />
        <MatchContext visible={false} data-id="element-1471" />
        <IntentLinks data-id="element-1472" />
        <PerformanceMetrics data-id="element-1473" />
        <SellerReviews data-id="element-1474" />
        <MarketsServed data-id="element-1475" />
        <AgentCapabilities data-id="element-1476" />
        <ActiveListings data-id="element-1477" />
      </main>

      <footer className="py-12 text-center text-sm text-brand-muted" data-id="element-1478">
        <p data-id="element-1479">© 2026 Eaves Technologies LLC</p>
      </footer>

      {/* Floating Admin Button */}
      <Link to="/admin" className="fixed bottom-6 right-6 bg-brand-dark text-white p-3 rounded-full shadow-premium hover:bg-brand-forest transition-colors z-50 flex items-center justify-center group" aria-label="Admin Dashboard" data-id="element-1480">
        <Settings size={24} className="group-hover:rotate-45 transition-transform duration-300" data-id="element-1481" />
      </Link>
    </div>;
}